(() => {
  if (window.Shopify?.designMode) return;

  const manualKey = 'lunburg:language-choice';
  const checkedKey = 'lunburg:norwegian-language-checked';
  const rememberChoice = event => {
    const button = event.type === 'submit'
      ? event.submitter
      : event.target.closest('button[name="locale_code"], button[name="language_code"]');
    if (!button?.form?.matches('.shopify-localization-form') ||
        !['locale_code', 'language_code'].includes(button.name)) return;

    try {
      localStorage.setItem(manualKey, button.value);
    } catch {
      // Keep the native selector usable when browser storage is unavailable.
    }
  };

  // Capture B2B choices before its handler replaces the native form submission.
  document.addEventListener('click', rememberChoice, true);
  document.addEventListener('submit', rememberChoice, true);

  const form = document.getElementById('NorwegianLanguagePreference');
  const preferred = (navigator.languages?.[0] || navigator.language || '').toLowerCase().split('-')[0];
  if (!form || !['no', 'nb', 'nn'].includes(preferred)) return;

  try {
    if (localStorage.getItem(manualKey) || sessionStorage.getItem(checkedKey)) return;
    sessionStorage.setItem(checkedKey, '1');
  } catch {
    // Automatic switching needs a working loop guard; manual selection still works.
    return;
  }

  if (document.documentElement.lang.toLowerCase() === 'no') return;
  form.elements.return_to.value = location.pathname + location.search + location.hash;
  form.submit();
})();
